import { type StatusType, Translation } from '../../../../domain'

import { useTranslator } from '../../Internationalization'

export const mapTranslationParameters = (status: StatusType): Parameters<ReturnType<typeof useTranslator>['formatTranslation']> => [
    Translation.STATUS_LABEL,
    { status },
]

export const useStatusTranslator = (): ((status: StatusType) => string) => {
    const translator = useTranslator()
    return (status) => translator.formatTranslation(...mapTranslationParameters(status))
}
